import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { customElement as n } from '../../../../node_modules/@lit/reactive-element/decorators/custom-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { BaseWithUtils } from '../../lit-mixins/base-with-utils/index.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import { renderLayout } from './layout/index.js';
import css_248z from './feature-highlight-plus.scss.js';

const LitElementWithUtils = BaseWithUtils(s);
let FeatureHighlightPlus = class FeatureHighlightPlus extends LitElementWithUtils {
    constructor() {
        super(...arguments);
        this.sectionTitle = '';
        this.sectionTitleId = 'feature-section-title';
        this.hideSectionTitle = false;
        this.cards = [];
        this.rtl = false;
        this.query = '(max-width: 767px)';
        this.isMobile = false;
    }
    handleMediaQuery(event) {
        this.isMobile = event.detail.value;
    }
    connectedCallback() {
        var _a;
        (_a = super.connectedCallback) === null || _a === void 0 ? void 0 : _a.call(this);
        this.setAttribute('role', 'region');
    }
    firstUpdated() {
        this.announceRegion();
    }
    announceRegion() {
        var _a;
        const announcement = `${this.sectionTitle} section loaded with ${this.cards.length} feature${this.cards.length !== 1 ? 's' : ''}`;
        const liveRegion = document.createElement('div');
        liveRegion.setAttribute('role', 'status');
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.setAttribute('aria-atomic', 'true');
        liveRegion.className = 'sr-only';
        liveRegion.textContent = announcement;
        (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.appendChild(liveRegion);
        setTimeout(() => liveRegion.remove(), 1000);
    }
    render() {
        var _a;
        const direction = this.rtl || isRTL() ? 'rtl' : 'ltr';
        return $ `<section class="feature-section ${direction} ${(_a = this.utilityClasses) !== null && _a !== void 0 ? _a : ''}" aria-labelledby="${this.sectionTitleId}" dir="${direction}">${renderLayout(this)}</section><lit-media-query .query="${this.query}" @changed="${this.handleMediaQuery}"></lit-media-query>`;
    }
};
FeatureHighlightPlus.styles = [LitElementWithUtils.styles || [], css_248z];
__decorate([
    e({ type: String, attribute: 'section-title' })
], FeatureHighlightPlus.prototype, "sectionTitle", void 0);
__decorate([
    e({ type: String, attribute: 'section-title-id' })
], FeatureHighlightPlus.prototype, "sectionTitleId", void 0);
__decorate([
    e({ type: Boolean, reflect: true, attribute: 'hide-section-title' })
], FeatureHighlightPlus.prototype, "hideSectionTitle", void 0);
__decorate([
    e({
        type: Array,
        converter: {
            fromAttribute: (value) => {
                if (!value) {
                    return [];
                }
                try {
                    const parsed = JSON.parse(value);
                    return Array.isArray(parsed) ? parsed : [];
                }
                catch (_a) {
                    return [];
                }
            },
            toAttribute: (value) => JSON.stringify(value),
        },
    })
], FeatureHighlightPlus.prototype, "cards", void 0);
__decorate([
    e({ type: Boolean })
], FeatureHighlightPlus.prototype, "rtl", void 0);
__decorate([
    t()
], FeatureHighlightPlus.prototype, "query", void 0);
__decorate([
    t()
], FeatureHighlightPlus.prototype, "isMobile", void 0);
FeatureHighlightPlus = __decorate([
    n('feature-highlight-plus')
], FeatureHighlightPlus);

export { FeatureHighlightPlus };
